import React, { useLayoutEffect } from 'react';
import { ControlQuery, useControlFrameworkDetailsQuery } from 'src/graphql/_generated';
import _ from 'lodash';
import GenericTable, { TableSheetControlLibrary, useControlLibraryColumns } from 'src/components/GenericTable';
import { TableIds } from 'src/api/types/misc';
import Button from 'src/components/form/Button';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';
import { Spacer } from 'src/common';
import { useColumns } from '../../useColumns';
import { isQueryLoading } from 'src/graphql';

interface FromSuggestedProps {
  setChecked: (a: string[]) => void;
  onSubmit: () => void;
  isSubmitting?: boolean;
  existingFrameworkControlIds: string[];
  control: NonNullable<ControlQuery['control']>;
}

export const FromSuggested: React.FC<FromSuggestedProps> = ({
  setChecked,
  onSubmit,
  isSubmitting,
  existingFrameworkControlIds,
  control,
}) => {
  const { data, loading, networkStatus } = useControlFrameworkDetailsQuery();
  const isLoading = isQueryLoading({ data, loading, networkStatus });

  const uniqControls = _.uniqBy(
    control.frameworkControls.flatMap((el) => el.compatibleControls),
    'id',
  );

  const { columns, checked, GTColumnSelectAnchorExported } = useColumns({
    data: uniqControls,
    isCheckerEnabled: true,
    tableId: TableIds.addControlControlLib,
    existingFrameworkControlIds,
  });

  useLayoutEffect(() => {
    setChecked(checked);
  }, [checked, setChecked]);

  return (
    <>
      <GenericTable
        tableId={TableIds.suggestFrameworks}
        data={uniqControls}
        columns={columns}
        GTColumnSelectAnchorExported={GTColumnSelectAnchorExported}
        expandContent={(row) => <TableSheetControlLibrary data={row} />}
        searchable
        itemHeight={50}
        rowDisabled={(row) => existingFrameworkControlIds.includes(row.id)}
      />
      <Spacer $px={30} />
      <Button
        disabled={isSubmitting || checked.length === 0}
        onClick={() => {
          onSubmit();
          mpEvent(MPEvents.ButtonClick, {
            button: 'Link',
            modal: 'Suggest frameworks modal',
            tags: ['CONTROL', 'RMP', 'FRAMEWORK'],
          });
        }}
        primary
        css="width: 100%;"
        data-cy="submit-btn"
      >
        LINK FRAMEWORK TO CONTROL
      </Button>
    </>
  );
};
